import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-4 sm:px-8 py-24 sm:py-32 text-center min-h-[60vh]" data-testid="payment-cancel-page">
      <XCircle className="mx-auto text-graytx" size={48} />
      <h1 className="font-display font-extrabold text-5xl uppercase mt-6 leading-[0.9]">Checkout cancelled</h1>
      <p className="text-graytx mt-5">No charge was made — your bag is still saved. Pick up where you left off whenever you're ready.</p>
      <Link to="/shop" data-testid="cancel-shop-link" className="inline-block mt-8 bg-cream text-bg font-mono text-[11px] uppercase tracking-[0.2em] px-8 py-4 hover:bg-cs-yellow transition-colors duration-200">Return to shop</Link>
    </div>
  );
}
